import { ShipstationIntegrationApiClient } from '@fourthwall/services/dist/ShipstationIntegrationApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useShipStationStoresQuery = createQueryHook(
  ShipstationIntegrationApiClient.getShipstationStores,
  {
    queryKey: ['shipStationStores'],
  },
)
